import api from './base'

export default {
  getAll () {
    return api().get(`company/users`)
  },
  getAllPerHeaders (headers) {
    return api().get(`company/users`, { headers: headers })
  },
  getById ({ id }) {
    return api().get(`company/users/${id}`)
  },
  save ({ item }) {
    return api().put(`company/users`, item)
  },
  delete ({ id }) {
    return api().delete(`company/users/${id}`)
  },
  savePassword ({ userId, data }) {
    return api().put(`company/users/${userId}/password`, data)
  },
  savePin ({ userId, data }) {
    return api().put(`company/users/${userId}/pin`, data)
  }
}
